import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const checkboxOutlineBlankIconComponent = {
  root: 'checkbox-outline-blank-icon.root',
} as const satisfies ComponentLocatorMap;
